import { API as e, Resource as t } from "@coveo/platform-client";
//#region src/resources/CaseAssistConfigstInternalResource.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/caseassists`;
	}
	listCaseAssistConfigsByProjectId(e, t = {}) {
		return this.api.get(this.buildPath(`${n.baseUrl}/projects/get`, {
			...t,
			projectId: e
		}));
	}
};
//#endregion
export { n as CaseAssistConfigsInternalResource };

//# sourceMappingURL=CaseAssistConfigstInternalResource.js.map